import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M3 — SABREUR. Le professeur du côté SÛR.
 *
 *  Il se poste à mi-hauteur, oscille largement d'un flanc à l'autre, et projette
 *  sous lui un FAISCEAU persistant : une lame verticale de danger qui balaie le
 *  terrain au rythme de son va-et-vient. Le faisceau ne vole pas — il est là,
 *  ancré sous l'ennemi, et suit chacun de ses déplacements.
 *
 *  ── Ce qu'il enseigne ──
 *  Qu'un danger a un SENS de déplacement, et qu'il existe toujours un côté déjà
 *  balayé. Fuir devant la lame, c'est courir jusqu'au mur puis se faire coincer
 *  à l'inversion ; se glisser DERRIÈRE elle, dans l'espace qu'elle vient de
 *  quitter, c'est être en sûreté tant qu'elle n'est pas revenue. Le joueur
 *  apprend à lire non pas où est le danger, mais où il ne sera pas de sitôt.
 *
 *  ── Pourquoi il ne descend pas jusqu'au joueur ──
 *  Le faisceau s'arrête bien au-dessus de la rangée basse (il reste au-dessus de
 *  Y = −180, la ligne sous laquelle aucun tir ne surgit sans télégraphe) : c'est
 *  une barrière de mi-terrain, pas une exécution. La tension naît de ce qu'il
 *  faut MONTER dans sa zone pour l'abattre — s'exposer à la lame pour la faire
 *  taire, ou l'endurer. Un faisceau qui atteindrait la rangée de départ tuerait
 *  à la réapparition et deviendrait de l'arbitraire.
 *
 *  ── Il pulse ──
 *  1,1 s de faisceau toutes les 3,0 s : les 1,9 s de silence rouvrent le terrain
 *  et donnent la fenêtre où l'on traverse ou l'on riposte. Un faisceau permanent
 *  ne serait plus une menace à lire mais un mur, c'est-à-dire une zone morte. */
export default defineEnemy({
  id: 'sabreur',
  rank: Rank.Heavy,
  hp: 300,
  visualRadius: 34,
  score: 340,
  telegraph: 1.2,
  drops: 3,
  // Hover à large amplitude : la station est le point de balayage, l'oscillation
  // ±247 u (amplitude / fréquence) est le balayage lui-même. Le faisceau, ancré
  // dessous, hérite du mouvement sans qu'on ait à le décrire deux fois.
  motion: { kind: Motion.Hover, speed: 220, amplitude: 210, frequency: 0.85, holdY: 300 },
  emitter: {
    pattern: Pattern.Beam,
    every: 3.0,
    // 20 segments sur 380 u = un pas de 20 u, sous le diamètre d'un projectile
    // (22 u) : la lame est pleine, sans pointillé où le joueur se faufilerait.
    count: 20,
    beamLen: 380,
    beamLife: 1.1,
    // `speed` ignoré (les segments sont ancrés, vitesse nulle) mais laissé nul
    // par honnêteté : un faisceau n'a pas de vitesse de vol.
    speed: 0,
    firstDelay: 2.0,
    family: Fam.EnemyRed,
  },
});
